export const SIDEBAR_WIDTH_EXPANDED = 260;
export const SIDEBAR_WIDTH_COLLAPSED = 90;
export const SIDEBAR_GUTTER = 30;

export const SERVICE_BUS_TRIGGER = 'SERVICE_BUS_TRIGGER';
export const HTTP_TRIGGER = 'HTTP_TRIGGER';
export const TIMER_TRIGGER = 'TIMER_TRIGGER';
export const SQL_DB = 'SQL_DB';
export const NO_SQL_DB = 'NO_SQL_DB';
export const SERVICE_BUS_PRODUCER = 'SERVICE_BUS_PRODUCER';
export const HTTP_CLIENT = 'HTTP_CLIENT';
export const WEB_CLIENT = 'WEB_CLIENT';
export const BLOB_STORAGE_PRODUCER = 'BLOB_STORAGE_PRODUCER';
export const BLOB_TRIGGER = 'BLOB_TRIGGER';